import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'enumKeyValue'
})
export class EnumKeyValuePipe implements PipeTransform {
    transform(enumType: any) {
        return Object.keys(enumType)
            .filter(key => isNaN(+key))
            .map(key => {
                return { key, value: enumType[key] };
            });
    }
}
